"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _Close = _interopRequireDefault(require("../../icons/utils/Close"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Close = _styledComponents.default.a.withConfig({
  displayName: "CloseLink__Close",
  componentId: "sc-164kuuj-0"
})(["&&{color:", ";}min-width:", ";padding:", ";line-height:0;:hover{background-color:", ";border-radius:50%;cursor:pointer;}", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.luna ? theme.luna.colors.ultramarine(60) : theme.colors.system.cta.base;
}, (0, _polished.rem)('10px'), (0, _polished.rem)('7px'), function (props) {
  return props.theme.luna ? props.theme.luna.colors.neutral(10) : 'transparent';
}, function (_ref2) {
  var media = _ref2.theme.media;
  return media.smallMedium((0, _styledComponents.css)(["margin-left:", ";"], function (props) {
    return props.theme.spacing.medium;
  }));
});

var CloseLink = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(CloseLink, _React$PureComponent);

  var _super = _createSuper(CloseLink);

  function CloseLink(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CloseLink);
    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CloseLink, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          canClose = _this$props.canClose,
          onClose = _this$props.onClose;
      var classes = 'ui-inline-notification-close'; // show x if onClose is provided, also allow canClose override(for backward compatibilty)

      if (onClose && (canClose === undefined || canClose)) {
        return /*#__PURE__*/_react.default.createElement(Close, {
          className: classes,
          href: "#",
          onClick: this.handleClick,
          "aria-label": "Close notification"
        }, /*#__PURE__*/_react.default.createElement(_Close.default, null));
      }

      return /*#__PURE__*/_react.default.createElement("span", {
        className: classes
      });
    }
  }]);
  return CloseLink;
}(_react.default.PureComponent);

CloseLink.propTypes = {
  canClose: _propTypes.default.bool,
  onClose: _propTypes.default.func
};
var _default = CloseLink;
exports.default = _default;
//# sourceMappingURL=CloseLink.js.map